import { auth } from '../config/firebase';

const FUNCTIONS_URL = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL || 'https://us-central1-chess-web-host.cloudfunctions.net';

/**
 * Helper: authenticated POST to a Cloud Function
 */
async function authenticatedPost(endpoint, body) {
  const user = auth.currentUser;
  if (!user) throw new Error('User not authenticated');

  const idToken = await user.getIdToken();
  const response = await fetch(`${FUNCTIONS_URL}/${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}

/**
 * Coach creates their membership offering
 * @param {{ coachId: string, priceUsd: number, creditsPerCycle: number, perks: string[], lessonsRequireMembership?: boolean, defaultLibraryToMembers?: boolean }} params
 * @returns {Promise<{ success: boolean, membership: object }>}
 */
export async function createCoachMembership({ coachId, priceUsd, creditsPerCycle, perks, lessonsRequireMembership, defaultLibraryToMembers }) {
  return authenticatedPost('createCoachMembership', {
    coachId,
    priceUsd,
    creditsPerCycle,
    perks,
    lessonsRequireMembership,
    defaultLibraryToMembers,
  });
}

/**
 * Student starts a membership checkout session
 * @param {string} coachId
 * @returns {Promise<{ success: boolean, sessionId: string, url: string }>}
 */
export async function createMembershipCheckoutSession(coachId) {
  return authenticatedPost('createMembershipCheckoutSession', { coachId });
}

/**
 * Student claims a free trial lesson (1 purchased credit)
 * @param {string} coachId
 * @returns {Promise<{ success: boolean, credits: number }>}
 */
export async function claimFreeTrialLesson(coachId) {
  return authenticatedPost('claimFreeTrialLesson', { coachId });
}

/**
 * Student cancels their own membership subscription
 * @param {string} coachId
 * @returns {Promise<{ success: boolean, message: string, subscriptionStatus: string }>}
 */
export async function cancelMembership(coachId) {
  return authenticatedPost('cancelMembershipSubscription', { coachId });
}
